<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h3 class="mx-3">Activity</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-form ref="activityForm" v-model="valid" lazy-validation>
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="ma-3"
                v-model="date"
                label="Date"
                readonly
                required
                :rules="[() => !!date || 'Date is required']"
                v-on="on"
              >
                <v-icon small slot="prepend">mdi-calendar</v-icon>
              </v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              @input="dateMenu = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="timeModal"
            v-model="timeMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="time"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="ma-3"
                v-model="time"
                label="Time"
                readonly
                required
                :rules="[() => !!time || 'Time is required']"
                v-on="on"
              >
                <v-icon small slot="prepend">mdi-clock-outline</v-icon>
              </v-text-field>
            </template>
            <v-time-picker
              v-if="timeMenu"
              v-model="time"
              format="24hr"
              :allowed-minutes="(m) => m % 5 === 0"
              @click:minute="$refs.timeModal.save(time)"
            ></v-time-picker>
          </v-menu>
          <v-text-field
            class="ma-3"
            label="Duration"
            type="number"
            required
            :rules="[() => !!duration || 'Duration is required']"
            v-model="duration"
          >
            <v-icon small slot="prepend">mdi-timer-outline</v-icon>
          </v-text-field>
          <v-combobox
            class="ma-3"
            label="Workout"
            small-chips
            deletable-chips
            :items="itemsWorkoutName"
            v-model="workoutName"
            @change="getWorkout(workoutName)"
          >
            <v-icon small slot="prepend">mdi-weight-lifter</v-icon>
          </v-combobox>
          <v-row v-if="workoutTotals.reps">
            <v-col cols="4">
              <p class="ml-5">Totals</p>
            </v-col>
            <v-col cols="4">
              <p>{{ workoutTotals.reps }} Reps</p>
            </v-col>
            <v-col cols="4">
              <p>{{ workoutTotals.sets }} Sets</p>
            </v-col>
            <v-col
              cols="6"
              v-for="(tReps, tExercise) in workoutTotals.exercise"
              :key="tExercise.index"
            >
              <span class="mx-5 subtitle-2">{{ tReps }} </span>
              <span class="caption">{{ tExercise }}</span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="justify-space-around my-4">
            <v-btn text icon @click="selectDeselect">
              <v-icon text>mdi-select-all</v-icon>
            </v-btn>
            <v-btn text icon @click="selectDeleteCopy('copy')">
              <v-icon text>mdi-content-copy</v-icon>
            </v-btn>
            <v-btn text icon @click="selectDeleteCopy('delete')">
              <v-icon text>mdi-delete-outline</v-icon>
            </v-btn>
          </v-row>
          <v-divider></v-divider>
          <v-list subheader text color="#131313" class="ma-3">
            <v-subheader>WORKOUT</v-subheader>
            <draggable
              v-model="workoutSelected"
              group="people"
              @start="drag = true"
              @end="drag = false"
            >
              <v-list-item
                v-for="(set, index) in workoutSelected"
                :key="set.uuid"
              >
                <v-list-item-action>
                  <v-checkbox small v-model="set.selected"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content @click="set.selected = !set.selected">
                  <v-list-item-title class="text--primary"
                    >{{ set.reps }} {{ set.exercise }}</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn small text icon @click="editExerciseListItem(index)">
                    <v-icon small text>mdi-pencil-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </draggable>
          </v-list>
          <v-row class="justify-center">
            <v-btn text icon @click="addNewExercise">
              <v-icon text>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </v-row>
          <v-row class="justify-center">
            <v-slider
              class="ma-5 caption"
              v-model="health"
              :color="healthColor"
              :tick-labels="healthList"
              :max="4"
              step="1"
              ticks="always"
              tick-size="4"
              ><v-icon small slot="prepend">
                mdi-heart-outline
              </v-icon>
            </v-slider>
          </v-row>
          <v-divider class="my-4"></v-divider>
        </v-form>
        <v-row class="justify-center">
          <v-btn
            class="mx-3"
            small
            fab
            color="secondary"
            :disabled="!valid"
            @click="upsertWorkout"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="exerciseDialog" persistent max-width="600px">
      <v-form ref="exerciseForm" v-model="validSubmitExercise" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline">Edit Exercise</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Reps"
                    type="number"
                    v-model="exerciseReps"
                    :rules="[() => !!exerciseReps || 'Reps are required']"
                    required
                  >
                    <v-icon small slot="prepend">mdi-counter</v-icon>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-combobox
                    label="Exercise"
                    small-chips
                    deletable-chips
                    :items="itemsExercise"
                    v-model="exerciseExercise"
                    :rules="[
                      () => !!exerciseExercise || 'Exercise is required',
                    ]"
                    required
                  >
                    <v-icon small slot="prepend">mdi-dumbbell</v-icon>
                  </v-combobox>
                  <v-combobox
                    label="Muscle Group"
                    small-chips
                    deletable-chips
                    :items="itemsMuscleGroup"
                    v-model="exerciseMuscleGroup"
                    :rules="[
                      () => !!exerciseMuscleGroup || 'Muscle Group is required',
                    ]"
                    required
                  >
                    <v-icon small slot="prepend">mdi-weight-lifter</v-icon>
                  </v-combobox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="exerciseDialog = false"
              >Close</v-btn
            >
            <v-btn
              v-if="addOrEdit == 'edit'"
              color="blue darken-1"
              text
              @click="addOrSaveExercise"
              :disabled="!validSubmitExercise"
              >Save</v-btn
            >
            <v-btn
              v-if="addOrEdit == 'add'"
              color="blue darken-1"
              text
              @click="addOrSaveExercise"
              :disabled="!validSubmitExercise"
              >Add</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-row>
      <v-col cols="12">
        <v-snackbar
          v-model="snackbarModel"
          bottom
          :color="snackbarColor"
          :timeout="snackbarTimeout"
        >
          {{ snackbarText }}
          <v-btn dark text @click="snackbarModel = false">
            Close
          </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { mapState } from "vuex";
import draggable from "vuedraggable";
import getsheetobj from "@/mixins/getsheetobj";

export default {
  name: "Activity",
  mixins: [getsheetobj],
  components: { draggable },
  data: () => ({
    repCheckbox: false,
    settings: [],
  }),
  watch: {
    exerciseExercise() {
      // Check if exerciseExercise is new
      if (
        typeof this.exerciseExercise === "string" && // type is a string
        !this.itemsExercise.includes(this.exerciseExercise) && // not already in the list
        this.exerciseExercise !== "" // when the form is reset, it creates an empty row in Vendor
      ) {
        // create a new row for the vendor
        const id = this.sheetsObj["exercise"].maxId + 1;
        const uuid = uuidv4();
        const newExercise = this.exerciseExercise;
        const params = {
          spreadsheetId: this.sheetId,
          valueInputOption: "RAW",
          range: "exercise",
          insertDataOption: "INSERT_ROWS",
        };
        const valueRangeBody = {
          majorDimension: "ROWS",
          values: [[id, uuid, newExercise]],
        };
        // update the sheet
        this.$gapi.getGapiClient().then((gapi) => {
          gapi.client.sheets.spreadsheets.values
            .append(params, valueRangeBody)
            .then(() => {
              // fecth the updated sheets
              this.getEditFormFields(this.sheetId, this.allSheets);
            });
        });
      }
      // if not new, simply return the exercise
      return this.exerciseExercise;
    },
    exerciseMuscleGroup() {
      // Check if exerciseMuscleGroup is new
      if (
        typeof this.exerciseMuscleGroup === "string" && // type is a string
        !this.itemsMuscleGroup.includes(this.exerciseMuscleGroup) && // not already in the list
        this.exerciseMuscleGroup !== "" // when the form is reset, it creates an empty row in Vendor
      ) {
        // create a new row for the vendor
        const id = this.sheetsObj["exercise"].maxId + 1;
        const uuid = uuidv4();
        const newMuscleGroup = this.exerciseMuscleGroup;
        const params = {
          spreadsheetId: this.sheetId,
          valueInputOption: "RAW",
          range: "muscleGroup",
          insertDataOption: "INSERT_ROWS",
        };
        const valueRangeBody = {
          majorDimension: "ROWS",
          values: [[id, uuid, newMuscleGroup]],
        };
        // update the sheet
        this.$gapi.getGapiClient().then((gapi) => {
          gapi.client.sheets.spreadsheets.values
            .append(params, valueRangeBody)
            .then(() => {
              // fecth the updated sheets
              this.getEditFormFields(this.sheetId, this.allSheets);
            });
        });
      }
      // if not new, simply return the exercise
      return this.exerciseMuscleGroup;
    },
  },
  computed: {
    ...mapState({
      isAuthenticated: (state) => state.auth.isAuthenticated,
      sheetId: (state) => state.sheet.sheetId,
      activitySheet: (state) => state.activity.activitySheet,
      sheetsObj: (state) => state.sheet.sheetsObj,
      allSheets: (state) => state.sheet.allSheets,
      activitySheetObj: (state) => state.activity.activitySheetObj,
      itemsWorkoutName: (state) => state.activity.workout.items,
      itemsExercise: (state) => state.edit.lists.exercise,
      itemsMuscleGroup: (state) => state.edit.lists.muscleGroup,
      workoutName: (state) => state.activity.workout.name,
      healthList: (state) => state.activity.health.list,
      workoutTotals: (state) => state.activity.workout.totals,
      snackbarText: (state) => state.activity.snackbar.text,
      snackbarColor: (state) => state.activity.snackbar.color,
      snackbarTimeout: (state) => state.activity.snackbar.timeout,
    }),
    valid: {
      get() {
        return this.$store.state.activity.valid;
      },
      set(value) {
        const payload = {
          state: "valid",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    date: {
      get() {
        return this.$store.state.activity.date.date;
      },
      set(value) {
        const payload = {
          state: "date",
          field: "date",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    dateMenu: {
      get() {
        return this.$store.state.activity.date.menu;
      },
      set(value) {
        const payload = {
          state: "date",
          field: "menu",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    time: {
      get() {
        return this.$store.state.activity.time.time;
      },
      set(value) {
        const payload = {
          state: "time",
          field: "time",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    timeMenu: {
      get() {
        return this.$store.state.activity.time.menu;
      },
      set(value) {
        const payload = {
          state: "time",
          field: "menu",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    duration: {
      get() {
        return this.$store.state.activity.duration;
      },
      set(value) {
        const payload = {
          state: "duration",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    workoutName: {
      get() {
        return this.$store.state.activity.workout.name;
      },
      set(value) {
        const payload = {
          state: "workout",
          field: "name",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    workoutSelected: {
      get() {
        return this.$store.state.activity.workout.selected;
      },
      set(value) {
        const payload = {
          state: "workout",
          field: "selected",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    exerciseDialog: {
      get() {
        return this.$store.state.activity.exercise.dialog;
      },
      set(value) {
        const payload = {
          state: "exercise",
          field: "dialog",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    exerciseReps: {
      get() {
        return this.$store.state.activity.exercise.reps;
      },
      set(value) {
        const payload = {
          state: "exercise",
          field: "reps",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    exerciseExercise: {
      get() {
        return this.$store.state.activity.exercise.exercise;
      },
      set(value) {
        const payload = {
          state: "exercise",
          field: "exercise",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    exerciseMuscleGroup: {
      get() {
        return this.$store.state.activity.exercise.muscleGroup;
      },
      set(value) {
        const payload = {
          state: "exercise",
          field: "muscleGroup",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    validSubmitExercise: {
      get() {
        return this.$store.state.activity.exercise.valid;
      },
      set(value) {
        const payload = {
          state: "exercise",
          field: "valid",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    addOrEdit: {
      get() {
        return this.$store.state.activity.exercise.addOrEdit;
      },
      set(value) {
        const payload = {
          state: "exercise",
          field: "addOrEdit",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    exerciseIndex: {
      get() {
        return this.$store.state.activity.exercise.index;
      },
      set(value) {
        const payload = {
          state: "exercise",
          field: "index",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    selectDeselectAll: {
      get() {
        return this.$store.state.activity.selectDeselectAll;
      },
      set(value) {
        const payload = {
          state: "selectDeselectAll",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    health: {
      get() {
        return this.$store.state.activity.health.value;
      },
      set(value) {
        const payload = {
          state: "health",
          field: "value",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
    healthColor() {
      if (this.health === 0) return "red";
      if (this.health === 1) return "orange";
      if (this.health === 2) return "teal";
      if (this.health === 3) return "green darken-1";
      if (this.health === 4) return "green darken-4";
      return "primary";
    },
    snackbarModel: {
      get() {
        return this.$store.state.activity.snackbar.model;
      },
      set(value) {
        const payload = {
          state: "snackbar",
          field: "model",
          value: value,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      },
    },
  },
  methods: {
    async getActivitySheetData() {
      const range = this.activitySheet;
      if (this.isAuthenticated) {
        try {
          const gapic = await this.$gapi.getGapiClient(); // init client
          const response = await gapic.client.sheets.spreadsheets.values.batchGet(
            {
              spreadsheetId: this.sheetId,
              ranges: range,
            }
          );
          const activitySheetData = response.result.valueRanges[0].values;
          return activitySheetData;
        } catch (err) {
          console.log("getActivitySheet error: ", err);
        }
      }
    },
    async createActivitySheetObj(activitySheetData) {
      let activitySheetObj = {};
      let newWorkout;
      let oneSet;
      let numOfReps;
      let numOfSets;
      let maxId = 0;
      let key;

      activitySheetData.forEach((activity, index) => {
        // if this is a new workout
        if (activity[0]) {
          // keep incrementing maxId if the new workout ID is greater than previous maxId
          if (parseFloat(activity[0]) > maxId) {
            maxId = activity[0];
          }
          // key = `${activity[4]}-${activity[0]}-${activity[2]}-${activity[3]}`;
          // Make key the name of the workout - could be repeats then you only need to save one (overwrite)
          key = `${activity[4]}`;

          //
          activitySheetObj["maxId"] = maxId;
          activitySheetObj[key] = {};
          activitySheetObj[key]["id"] = activity[0];
          activitySheetObj[key]["uuid"] = activity[1];
          activitySheetObj[key]["name"] = activity[4];
          activitySheetObj[key]["date"] = activity[2];
          activitySheetObj[key]["time"] = activity[3];
          activitySheetObj[key]["duration"] = activity[5];
          activitySheetObj[key]["totals"] = activity[6];
          activitySheetObj[key]["feel"] = activity[10];
          activitySheetObj[key]["rowNumber"] = index + 1;

          numOfSets += 1;
          activitySheetObj[key]["numOfSets"] = numOfSets;

          numOfReps += parseFloat(activity[7]);
          activitySheetObj[key]["numOfReps"] = numOfReps;

          // Create a list of workouts/sets
          activitySheetObj[key]["workout"] = [];

          // Create one set
          oneSet = {};
          oneSet["uuid"] = activity[1];
          oneSet["reps"] = activity[7];
          oneSet["exercise"] = activity[8];
          oneSet["muscleGroup"] = activity[9];
          oneSet["rowNumber"] = index + 1;
          oneSet["selected"] = false;

          // Push to the workout list
          activitySheetObj[key]["workout"].push(oneSet);

          if (activitySheetData[index + 1]) {
            if (!activitySheetData[index + 1][0]) {
              newWorkout = false;
            } else {
              newWorkout = true;
              numOfSets = 0;
              numOfReps = 0;
            }
          } else {
            activitySheetObj["numOfRows"] = index + 1;
          }
        } else if (!newWorkout) {
          numOfSets += 1;
          activitySheetObj[key]["numOfSets"] = numOfSets;

          numOfReps += parseFloat(activity[7]);
          activitySheetObj[key]["numOfReps"] = numOfReps;

          oneSet = {};
          oneSet["uuid"] = activity[1];
          oneSet["reps"] = activity[7];
          oneSet["exercise"] = activity[8];
          oneSet["muscleGroup"] = activity[9];
          oneSet["rowNumber"] = index + 1;
          oneSet["selected"] = false;

          activitySheetObj[key]["workout"].push(oneSet);

          if (activitySheetData[index + 1]) {
            if (!activitySheetData[index + 1][0]) {
              newWorkout = false;
            } else {
              newWorkout = true;
              numOfSets = 0;
              numOfReps = 0;
            }
          } else {
            activitySheetObj["numOfRows"] = index + 1;
          }
        }
      });
      this.$store.dispatch("activity/updateActivityState", {
        state: "activitySheetObj",
        value: activitySheetObj,
      });
      return activitySheetObj;
    },
    async createActivities() {
      const activitySheetData = await this.getActivitySheetData();
      const activitySheetObj = await this.createActivitySheetObj(
        activitySheetData
      );
      return activitySheetObj;
    },
    createWorkoutNameList(activitySheetObj) {
      let itemsWorkoutName = [];
      Object.values(activitySheetObj).forEach((workout) => {
        if (workout.name && workout.name !== "name") {
          itemsWorkoutName.push(workout.name);
        }
      });
      this.$store.dispatch("activity/updateActivityState", {
        state: "workout",
        field: "items",
        value: itemsWorkoutName,
      });
    },
    getWorkout(workoutName) {
      let workout = [];
      if (this.itemsWorkoutName.includes(workoutName)) {
        workout = this.activitySheetObj[workoutName].workout;
      } else {
        workout = this.workoutSelected; // keep whatever is there, in case of name change
      }
      const payload = {
        state: "workout",
        field: "selected",
        value: workout,
      };
      this.$store.dispatch("activity/updateActivityState", payload);
      this.calculateTotals();
    },
    editExerciseListItem(index) {
      this.exerciseDialog = true;
      this.addOrEdit = "edit";
      this.exerciseIndex = index;
      this.exerciseReps = this.workoutSelected[index].reps;
      this.exerciseExercise = this.workoutSelected[index].exercise;
      this.exerciseMuscleGroup = this.workoutSelected[index].muscleGroup;
    },
    addOrSaveExercise() {
      if (this.addOrEdit == "edit") {
        this.workoutSelected[this.exerciseIndex].reps = this.exerciseReps;
        this.workoutSelected[
          this.exerciseIndex
        ].exercise = this.exerciseExercise;
        this.workoutSelected[
          this.exerciseIndex
        ].muscleGroup = this.exerciseMuscleGroup;
      } else if (this.addOrEdit == "add") {
        let newExerciseObj = {};
        newExerciseObj["reps"] = this.exerciseReps;
        newExerciseObj["exercise"] = this.exerciseExercise;
        newExerciseObj["muscleGroup"] = this.exerciseMuscleGroup;
        newExerciseObj["uuid"] = uuidv4();
        newExerciseObj["selected"] = false;
        newExerciseObj["rowNumber"] = "new";
        this.workoutSelected.push(newExerciseObj);
      }
      this.exerciseDialog = false;
      this.exerciseReps = "";
      this.exerciseExercise = "";
      this.exerciseMuscleGroup = "";
      this.calculateTotals();
    },
    addNewExercise() {
      this.exerciseDialog = true;
      this.addOrEdit = "add";
      this.exerciseReps = "";
      this.exerciseExercise = "";
      this.exerciseMuscleGroup = "";
      if (this.$refs.exerciseForm) {
        this.$refs.exerciseForm.resetValidation();
      }
    },
    selectDeselect() {
      if (this.selectDeselectAll === "select") {
        this.workoutSelected.forEach(function(set) {
          set.selected = false;
        });
        this.selectDeselectAll = "deselect";
      } else if (this.selectDeselectAll === "deselect") {
        this.workoutSelected.forEach(function(set) {
          set.selected = true;
        });
        this.selectDeselectAll = "select";
      }
    },
    selectDeleteCopy(which) {
      let updatedSelectedWorkout = this.workoutSelected;
      let selectedIndexes = [];
      for (let i = 0; i < this.workoutSelected.length; i++) {
        if (this.workoutSelected[i].selected === true) {
          selectedIndexes.push(i);
        }
      }
      if (which === "copy") {
        for (let k = 0; k < selectedIndexes.length; k++) {
          let index = selectedIndexes[k];
          let newSet = {};
          newSet["reps"] = this.workoutSelected[index].reps;
          newSet["exercise"] = this.workoutSelected[index].exercise;
          newSet["muscleGroup"] = this.workoutSelected[index].muscleGroup;
          newSet["uuid"] = uuidv4();
          newSet["selected"] = false;
          newSet["rowNumber"] = "";
          updatedSelectedWorkout.push(newSet);
        }
        const payload = {
          state: "workout",
          field: "selected",
          value: updatedSelectedWorkout,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      }
      if (which === "delete") {
        for (var j = selectedIndexes.length - 1; j >= 0; j--) {
          updatedSelectedWorkout.splice(selectedIndexes[j], 1);
        }
        const payload = {
          state: "workout",
          field: "selected",
          value: updatedSelectedWorkout,
        };
        this.$store.dispatch("activity/updateActivityState", payload);
      }
      this.calculateTotals();
    },
    calculateTotals() {
      let totals = {}; // object of reps by exercise and total reps and total sets
      totals["reps"] = 0;
      totals["sets"] = this.workoutSelected.length;
      totals["exercise"] = {};
      totals["muscleGroup"] = {};
      this.workoutSelected.forEach((set) => {
        // get totals by exercise and total reps
        if (!(set.exercise in totals.exercise)) {
          totals.exercise[set.exercise] = parseFloat(set.reps);
          let totalReps = totals["reps"] + parseFloat(set.reps);
          totals["reps"] = totalReps;
        } else {
          let newTotal = totals.exercise[set.exercise] + parseFloat(set.reps);
          totals.exercise[set.exercise] = newTotal;
          let totalReps = totals["reps"] + parseFloat(set.reps);
          totals["reps"] = totalReps;
        }
        // get totals by muscleGroup
        if (!(set.muscleGroup in totals.muscleGroup)) {
          totals.muscleGroup[set.muscleGroup] = parseFloat(set.reps);
        } else {
          let newTotal =
            totals.muscleGroup[set.muscleGroup] + parseFloat(set.reps);
          totals.muscleGroup[set.muscleGroup] = newTotal;
        }
      });
      const payload = {
        state: "workout",
        field: "totals",
        value: totals,
      };
      this.$store.dispatch("activity/updateActivityState", payload);
    },
    async upsertWorkout() {
      if (this.$refs.activityForm.validate()) {
        if (this.workoutSelected.length === 0) {
          console.log(
            "Activity form must include at least one (or more) exercises"
          );
        } else {
          const selectedWorkout = this.workoutSelected;
          // Create activity row and append to sheet
          const range = this.activitySheet; // tab name i.e. activity (state.activitySheet)
          let rows = []; // first row with name and stuff
          const id = parseFloat(this.activitySheetObj.maxId) + 1;
          rows.push([
            id,
            uuidv4(),
            this.date,
            this.time,
            this.workoutName,
            this.duration,
            JSON.stringify(this.workoutTotals, null, 2),
            this.workoutSelected[0].reps,
            this.workoutSelected[0].exercise,
            this.workoutSelected[0].muscleGroup,
            this.health,
          ]);
          selectedWorkout.forEach((set, index) => {
            if (!(index === 0)) {
              rows.push([
                "",
                uuidv4(),
                this.date,
                "",
                "",
                "",
                "",
                set.reps,
                set.exercise,
                set.muscleGroup,
                "",
              ]);
            }
          });
          if (this.isAuthenticated) {
            try {
              const gapic = await this.$gapi.getGapiClient(); // init client
              const params = {
                spreadsheetId: this.sheetId,
                valueInputOption: "RAW",
                range: range,
                insertDataOption: "INSERT_ROWS",
              };
              const valueRangeBody = {
                majorDimension: "ROWS",
                values: rows,
              };
              await gapic.client.sheets.spreadsheets.values.append(
                params,
                valueRangeBody
              );
              // get snackbar
              const snackbarColor = "secondary";
              const snackbarText = "New workout created!";
              this.getSnackbar(snackbarText, snackbarColor);
              this.clearActivityForm();

              // Refresh fields and sheetsObj
              const activitySheetsObj = await this.createActivities();
              this.createWorkoutNameList(activitySheetsObj);
            } catch (err) {
              console.error("insertFoodTypeError: ", err);
            }
          }
        }
      } else {
        console.log("Activity form is not valid");
      }
    },
    getSnackbar(snackbarText, snackbarColor) {
      this.$store.dispatch("activity/updateActivityState", {
        state: "snackbar",
        field: "text",
        value: snackbarText,
      });
      this.$store.dispatch("activity/updateActivityState", {
        state: "snackbar",
        field: "color",
        value: snackbarColor,
      });
      this.$store.dispatch("activity/updateActivityState", {
        state: "snackbar",
        field: "model",
        value: true,
      });
    },
    clearActivityForm() {
      this.$store.dispatch("activity/updateActivityState", {
        state: "date",
        field: "date",
        value: new Date(new Date().setHours(12, 59, 0, 0))
          .toISOString()
          .substr(0, 10),
      });
      this.$store.dispatch("activity/updateActivityState", {
        state: "time",
        field: "time",
        value: "",
      });
      this.$store.dispatch("activity/updateActivityState", {
        state: "duration",
        value: "",
      });
      this.$store.dispatch("activity/updateActivityState", {
        state: "workout",
        field: "name",
        value: "",
      });
      this.$store.dispatch("activity/updateActivityState", {
        state: "health",
        field: "value",
        value: 3,
      });
      this.$store.dispatch("activity/updateActivityState", {
        state: "workout",
        field: "selected",
        value: [],
      });
      if (this.$refs.activityForm) {
        this.$refs.activityForm.resetValidation();
      }
      this.$store.dispatch("activity/updateActivityState", {
        state: "workout",
        field: "totals",
        value: {
          sets: null,
          reps: null,
          exercise: {},
          muscleGroup: {},
        },
      });
    },
    async fixHealthScores(sheetId, sheet) {
      // one time to fix health from a scale of 100 to scale of 5
      if (this.isAuthenticated) {
        try {
          const gapic = await this.$gapi.getGapiClient(); // init client
          const range = sheet + "!K2:K";
          const newRange = sheet + "!L2:L";

          const currentHealth = await gapic.client.sheets.spreadsheets.values.batchGet(
            {
              spreadsheetId: sheetId,
              majorDimension: "COLUMNS",
              ranges: range,
            }
          );

          console.log(currentHealth.result.valueRanges[0].values[0]);

          const newHealth = currentHealth.result.valueRanges[0].values[0].map(
            (health) => {
              if (!health) return "";
              if (parseFloat(health) <= 20) return 0;
              if (parseFloat(health) <= 40) return 1;
              if (parseFloat(health) <= 60) return 2;
              if (parseFloat(health) <= 80) return 3;
              if (parseFloat(health) <= 100) return 4;
              return 3;
            }
          );

          console.log(newHealth);

          const response = await gapic.client.sheets.spreadsheets.values.batchUpdate(
            {
              spreadsheetId: sheetId,
              valueInputOption: "RAW",
              data: [
                {
                  majorDimension: "COLUMNS",
                  range: newRange,
                  values: [newHealth],
                },
              ],
            }
          );
          console.log(response);
        } catch (err) {
          console.error(err);
        }
      }
    },
  },
  async mounted() {
    if (!this.activitySheet.maxId) {
      const activitySheetsObj = await this.createActivities();
      this.createWorkoutNameList(activitySheetsObj);
    }
    // this.fixHealthScores(this.sheetId, this.activitySheet); // one time to fix health from a scale of 100 to scale of 5
  },
};
</script>
